import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { useQueryClient } from "react-query";

import PrimaryButton from "../../../Components/Buttons/primary-button";
import CheckBox from "../../../Components/Form Fields/checkbox";

import renderStatusModal from "../status-modal";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useCreateMyUtilitiesOrder } from "../../../CustomHooks/Mutations";

import { getUserSfid } from "../../../Utils/helpers";
import { modalVariants, APIQueryKeys } from "../../../Utils/constants";

import { MyUtilitiesMovingTruck } from "../../../Assets/Images";
import { CheckCircleWithShadow, CloseWithShadow } from "../../../Assets/Icons";

const myUtilitiesUpsellModalClassName = "my-utilities-upsell-modal position-close-button-over-content";

export default function renderMyUtilitiesUpsell(modalContext) {
  const { updateModalComponent, pushModalStack, setModalVariant, setModalClassName } = modalContext;

  updateModalComponent(MyUtilitiesUpsellModal);
  pushModalStack(() => renderMyUtilitiesUpsell(modalContext));
  setModalVariant(modalVariants.flexDialog);
  setModalClassName(myUtilitiesUpsellModalClassName);
}

const MyUtilitiesUpsellModal = () => {
  const modalContext = useModalContext();
  const { onModalClose, popModalStack } = modalContext;

  const queryClient = useQueryClient();

  const [hasConsented, setHasConsented] = useState(false);

  const { mutate: createOrder, isLoading: isCreatingOrder } = useCreateMyUtilitiesOrder({
    onSuccess: () => {
      queryClient.invalidateQueries(APIQueryKeys.consumerDeals);
      renderStatusModal(modalContext, {
        StatusIcon: CheckCircleWithShadow,
        title: "Success",
        description:
          "Your concierge will call you soon to help get you set up.",
        CTAButtonText: "Done",
        onCTAButtonClick: onModalClose,
      });
    },
    onError: () =>
      renderStatusModal(modalContext, {
        StatusIcon: CloseWithShadow,
        title: "We Couldn't Start Your Setup",
        description:
          "Something went wrong. Please try again in a few minutes. If the problem continues, contact Stake support for help.",
        CTAButtonText: "Try Again",
        onCTAButtonClick: () => popModalStack(0),
        secondaryCTAButtonText: "Cancel",
        onSecondaryCTAButtonClick: onModalClose,
      }),
  });

  const handleStartSaving = () => {
    createOrder({ sfid: getUserSfid() });
  };

  return (
    <>
      <div className="modal-image">
        <img className="my-utilities-bg" src={MyUtilitiesMovingTruck} alt="Moving truck illustration" />
      </div>
      <div className="modal-dialog-content mt-6">
        <h3 className="modal-status-title mb-4">
          Utilities & more
        </h3>
        <p className="modal-content-text color--mist mb-2">Moving is stressful enough. We make one part easier:</p>
        <p className="text-base-bold color--mist mb-0">Click below and our concierge team will reach out and help you get set up with whatever you need.</p>
      <div className="d-flex align-items-start gap-2 mt-4 mb-3">
        <CheckBox
          checked={hasConsented}
          onChange={(e) => setHasConsented(e.target.checked)}
          ariaLabelledBy="utilities-consent-label"
        />
        <p className="text-base-regular color--mist mb-0" id="utilities-consent-label">
          By selecting the checkbox, you consent to sharing your information for utilities setup.
        </p>
      </div>
      </div>
      <div className="action-container">
        <PrimaryButton
          className="primary-button"
          onClick={handleStartSaving}
          disabled={isCreatingOrder || !hasConsented}
        >
          Request A Call {isCreatingOrder && <CircularProgress />}
        </PrimaryButton>
      </div>
    </>
  );
};
